enum Color {
    Primary = "#1aa5cf",
    Secondary = "#1aa5cf",
    Grey = "#8f8f8f",
    Error = "#EC5467"
}

export default Color;